import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import Episode from '../../../domain/entities/Episode';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.ResetWriterCurrentUser:
      return {};
    case Types.IndexEpisodesSuccess: {
      const result = action.payload as PaginatedResult<Episode>;
      return mergeResponse(state, result);
    }
    case Types.CreateEpisodeSuccess: {
      const episode = action.payload as Episode;
      const newState = {} as QueryState;
      Object.keys(state).forEach(stateKey => {
        const response = {...state[stateKey]};
        if (stateKey.includes(`"storyId":${episode.storyId}`)) {
          response.pageToIds[1] = [...response.pageToIds[1], episode.id];
        }
        newState[stateKey] = response;
      });
      return newState;
    }
    case Types.DestroyEpisodeSuccess: {
      const id = action.payload as number;
      const destroyState = {} as QueryState;
      Object.keys(state).forEach(stateKey => {
        const response = {...state[stateKey]};
        Object.keys(response.pageToIds).forEach((pageKey: string) => {
          const nPageKey = Number(pageKey);
          response.pageToIds[nPageKey] = response.pageToIds[nPageKey].filter(
            episodeId => {
              return episodeId !== id;
            },
          );
        });
        destroyState[stateKey] = response;
      });
      return destroyState;
    }
    default:
      return state;
  }
}
